<template>
  <div id="app" @mouseover="isDon">
    <router-view/>
  </div>
</template>

<script>
import DevicePixelRatio from './utils/devicePixelRatio'

import {urlcode} from "@/config.js";

export default {
  name: "App",
  data() {
    return {
      timmer: null,
      logoutTime: null
    }
  },
  created() {
    localStorage.setItem("urlcode", urlcode);
    new DevicePixelRatio().init();
    this.moveEvent();
    this.isDon();
  },
  watch: {
    $route(to, from) {
      if (from.path == '/login') {
        this.moveEvent();
        this.isDon()
      }
    }
  },
  destroyed: function () {
    clearInterval(this.timmer);
    clearTimeout(this.logoutTime);
  },
  methods: {
    goBack() {
      sessionStorage.clear();
      localStorage.clear()
      this.$router.push({path: '/index'})
      clearInterval(this.timmer)
      clearTimeout(this.logoutTime)
    },
    isDon() {
      clearTimeout(this.logoutTime)
      // 30分钟无操作自动退出登录
      this.logoutTime = setTimeout(() => {
        if (this.$route.path !== '/index' && this.$route.path !== '/login') {
          alert("因您长时间无操作，即将退出系统");
          let id = localStorage.getItem('id');
          let realname = localStorage.getItem('realname');
          this.$api.get(`/sys/patient/addUsageLog?note=自动退出系统_${id + realname}`).finally((f) => {
            this.goBack();
            this.refrenToken()
          })
        }
      }, 60 * 60 * 1000)
    },
    moveEvent() {
      clearInterval(this.timmer)
      /*this.timmer = setInterval(() => {
        this.refrenToken()
      }, 30 * 60 * 1000 + 1000);*/
    },
    refrenToken() {
      localStorage.setItem("token", null);
      sessionStorage.setItem("token", null);
    }
  }
};
</script>

<style>
label {
  font-weight: 700;
}

.el-dialog {
  padding-bottom: 20px;
}

body {
  background-color: #ffffff;
  font-size: 16px;
  font-weight: 650;
}

</style>





// WEBPACK FOOTER //
// src/App.vue